import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import ZentraLogo from "@/components/ZentraLogo";

export default function ForcePasswordChange() {
    const { refresh } = useAuth();
    const navigate = useNavigate();
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmation, setConfirmation] = useState("");
    const [error, setError] = useState("");
    const [saving, setSaving] = useState(false);

    const submit = async (event) => {
        event.preventDefault();
        if (newPassword.length < 10) return setError("La nueva contraseña debe tener al menos 10 caracteres.");
        if (newPassword !== confirmation) return setError("Las contraseñas no coinciden.");
        setSaving(true);
        setError("");
        try {
            await api.post("/auth/change-password", { current_password: currentPassword, new_password: newPassword });
            await refresh();
            navigate("/", { replace: true });
        } catch (err) {
            setError(formatApiError(err));
        } finally {
            setSaving(false);
        }
    };

    return (
        <main className="min-h-screen bg-zentra-bg flex items-center justify-center p-5">
            <section className="zentra-card-static w-full max-w-md p-7 space-y-6">
                <ZentraLogo />
                <div><KeyRound className="text-zentra-accent-strong mb-3" /><h1 className="font-display text-2xl font-bold text-zentra-ink">Cambia tu contraseña temporal</h1><p className="text-sm text-zentra-muted mt-2">Debes establecer una contraseña personal antes de acceder a ZENTRA.</p></div>
                <form className="space-y-4" onSubmit={submit}>
                    <label className="block"><span className="zentra-label">Contraseña temporal</span><input required type="password" autoComplete="current-password" className="zentra-input w-full" value={currentPassword} onChange={(event) => setCurrentPassword(event.target.value)} /></label>
                    <label className="block"><span className="zentra-label">Nueva contraseña</span><input required type="password" minLength={10} autoComplete="new-password" className="zentra-input w-full" value={newPassword} onChange={(event) => setNewPassword(event.target.value)} /></label>
                    <label className="block"><span className="zentra-label">Repite la nueva contraseña</span><input required type="password" minLength={10} autoComplete="new-password" className="zentra-input w-full" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} /></label>
                    {error && <div className="rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-800">{error}</div>}
                    <button className="zentra-btn-primary w-full justify-center" disabled={saving}>{saving ? "Guardando…" : "Cambiar contraseña y continuar"}</button>
                </form>
            </section>
        </main>
    );
}
